import { makeAutoObservable, runInAction } from 'mobx'
import agent, { type TrendingResult } from '../api/agent'
import { Post } from '../models/post'

export default class FeedStore {
  trending: TrendingResult | null = null
  loadingTrending = false

  followingItems: Post[] = []
  followingCursor: string | null = null
  followingHasMore = true
  loadingFollowing = false
  loadingMore = false
  activeTagIds: string[] = []

  constructor () {
    makeAutoObservable(this)
  }

  loadTrending = async (limit = 10, days = 7) => {
    this.loadingTrending = true
    try {
      const result = await agent.Feed.trending(limit, days)
      runInAction(() => {
        this.trending = result
        this.loadingTrending = false
      })
    } catch {
      runInAction(() => {
        this.trending = null
        this.loadingTrending = false
      })
    }
  }

  loadFollowingFeed = async (pageSize = 20, tagIds?: string[]) => {
    const tags = tagIds ?? this.activeTagIds
    this.loadingFollowing = true
    this.followingItems = []
    this.followingCursor = null
    this.followingHasMore = true
    if (tagIds !== undefined) this.activeTagIds = tagIds
    try {
      const result = await agent.Feed.following(null, pageSize, tags.length ? tags : undefined)
      runInAction(() => {
        this.followingItems = result.items
        this.followingCursor = result.nextCursor
        this.followingHasMore = result.nextCursor !== null
        this.loadingFollowing = false
      })
    } catch {
      runInAction(() => {
        this.followingItems = []
        this.followingHasMore = false
        this.loadingFollowing = false
      })
    }
  }

  loadMoreFollowing = async (pageSize = 20) => {
    if (!this.followingHasMore || this.loadingMore) return
    this.loadingMore = true
    try {
      const tags = this.activeTagIds
      const result = await agent.Feed.following(this.followingCursor, pageSize, tags.length ? tags : undefined)
      runInAction(() => {
        this.followingItems = [...this.followingItems, ...result.items]
        this.followingCursor = result.nextCursor
        this.followingHasMore = result.nextCursor !== null
        this.loadingMore = false
      })
    } catch {
      runInAction(() => {
        this.loadingMore = false
      })
    }
  }

  resetFollowingFeed = () => {
    this.followingItems = []
    this.followingCursor = null
    this.followingHasMore = true
    this.loadingFollowing = false
    this.loadingMore = false
  }
}
